// extracted by mini-css-extract-plugin
export var clickableHeaderContent = "_bd-0";
export var headerCellHover = "_bd-1";
export var readCellContainer = "_bd-2";
export var readCellSlot = "_bd-3";
export var rowHoverCheckbox = "_bd-4";
export var rowUnreadIndicator = "_bd-5";
export var searchHighlight = "_bd-8";
export var supportTicketRow = "_bd-6";
export var unreadIndicator = "_bd-7";